import { Activity } from 'lucide-react';
import type { TraceSpan } from './traceFixture';

interface MiniTraceProps {
  spans: TraceSpan[];
  /** Monospace timing labels shown beneath the bars (e.g. "LLM 380ms"). */
  timings: string[];
}

/**
 * Compact execution-trace timeline — labelled span bars + a timing footer.
 * Mirrors the LabsPlanMyCareer SpanTimeline styling via the shared `--span-*`
 * tokens. Shared by AgentTraceCard and the hero AgentBuildWindow's Trace surface.
 */
export function MiniTrace({ spans, timings }: MiniTraceProps) {
  return (
    <div
      style={{
        border: '1px solid #e8eaed',
        borderRadius: '12px',
        padding: '12px',
        background: '#fff',
      }}
    >
      <div
        style={{
          fontSize: '11px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '.05em',
          color: 'var(--marketing-soft)',
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <Activity size={13} />
        Execution trace
      </div>
      {spans.map((span, i) => (
        <div
          key={i}
          className="agent-trace-row"
          style={{
            display: 'grid',
            gridTemplateColumns: '150px 1fr',
            gap: '10px',
            alignItems: 'center',
            padding: '3px 0',
          }}
        >
          <span
            style={{
              fontSize: '12.5px',
              color: 'var(--marketing-heading)',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            }}
          >
            {span.name}
          </span>
          <span style={{ position: 'relative', height: '16px', background: 'rgba(0,0,0,.04)', borderRadius: '6px' }}>
            <span
              style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: `${span.left}%`,
                width: `${span.width}%`,
                borderRadius: '6px',
                background: span.color,
              }}
            />
          </span>
        </div>
      ))}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '8px',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          color: '#718096',
        }}
      >
        {timings.map((t) => (
          <span key={t}>{t}</span>
        ))}
      </div>

      <style>{`
        @media (max-width: 767px) {
          .agent-trace-row { grid-template-columns: 108px 1fr !important; gap: 8px !important; }
        }
        @media (max-width: 560px) {
          .agent-trace-row { grid-template-columns: 96px 1fr !important; }
        }
      `}</style>
    </div>
  );
}
